import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import Login from '@/views/Auth/Login'
import Subscribe from '@/views/Auth/Subscribe'
import AnonymousLogin from '@/views/Auth/AnonymousLogin'
import AnonymousUpgrade from '@/views/Auth/AnonymousUpgrade'
import AnonymousSubscribe from '@/views/Auth/AnonymousSubscribe'
import EnterpriseSubscribe from '@/views/Auth/EnterpriseSubscribe'
import ResetPassword from '@/views/Auth/ResetPassword'

import Demo from '@/views/Demo'

import Main from '@/views/Main'
import Actualities from '@/views/Actualities/index'

import MyActualities from '@/views/Actualities/MyActualities'
import IndexActualities from '@/views/Actualities/IndexActualities'
import BanqueActualities from '@/views/Actualities/Banque'
import AllActualities from '@/views/Actualities/Actualities'

import Article from '@/common/components/article'

import Investments from '@/views/Investments/index'
import History from '@/views/Investments/History'
import Synthesis from '@/views/Investments/Synthesis'

import Advisor from '@/views/Advisor'
import Profile from '@/views/Profile'

import Documents from '@/views/Documents/index'
// import GeneralInformations from '@/views/Documents/GeneralInformations'
import MyDocuments from '@/views/Documents/MyDocuments'
import IndexPatrimonialLandscape from '@/views/Documents/PatrimonialLandscape/index'
import PatrimonialLandscape from '@/views/Documents/PatrimonialLandscape/PatrimonialLandscape'
import PatrimonialLandscapeUpdate from '@/views/Documents/PatrimonialLandscape/PatrimonialLandscapeUpdate'
import MySubscriptions from '@/views/Documents/MySubscriptions'

import IndexLegal from '@/common/components/Legal/index'
import CGU from '@/common/components/Legal/CGU'
import CGV from '@/common/components/Legal/CGV'
import Confidentiality from '@/common/components/Legal/Confidentiality'
import Legals from '@/common/components/Legal/Legals'

import FromSign from '@/views/FromSign'

import Maintenance from '@/views/Errors/Maintenance'

Vue.use(Router)

const myRouter = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			component: Main,
			name: 'Main',
			redirect: { name: 'MyActualities' },
			children: [
				{
					component: Actualities,
					redirect: { name: 'IndexActualities' },
					path: 'actualities',
					name: 'Actualities',
					children: [
						{
							component: IndexActualities,
							path: 'feed',
							name: 'IndexActualities',
							redirect: { name: 'MyActualities' },
							children: [
								{
									path: 'my-actualities',
									component: MyActualities,
									name: 'MyActualities'
								},
								{
									path: 'banque-de-conseils',
									component: BanqueActualities,
									name: 'BanqueOfConseils'
								},
								{
									path: 'all',
									component: AllActualities,
									name: 'AllActualities'
								}
							]
						},
						{
							name: 'Article',
							component: Article,
							path: 'article/:id'
						}
					]
				},
				{
					path: 'my-investments',
					component: Investments,
					name: 'MyInvestments',
					redirect: { name: 'Synthesis' },
					children: [
						{
							path: 'synthesis',
							name: 'Synthesis',
							component: Synthesis
						},
						{
							path: 'history',
							name: 'History',
							component: History
						}
					]
				},
				{
					path: 'advisor',
					component: Advisor,
					name: 'Advisor'
				},
				{
					path: 'documents',
					component: Documents,
					name: 'Documents',
					// redirect: {name: 'PatrimonialLandscape'},
					redirect: {name: 'MyDocuments'},
					children: [
						{
							path: 'profile',
							component: Profile,
							name: 'Profile'
						},
						{
							path: 'my-documents',
							component: MyDocuments,
							name: 'MyDocuments'
						},
						{
							path: 'my-patrimonial-landscape',
							component: IndexPatrimonialLandscape,
							redirectTo: {name: 'PatrimonialLandscape'},
							children: [
								{
									path: '',
									component: PatrimonialLandscape,
									name: 'PatrimonialLandscape'
								},
								{
									path: 'update/:section?',
									component: PatrimonialLandscapeUpdate,
									name: 'PatrimonialLandscapeUpdate'
								}
							]
						},
						{
							path: 'my-subscriptions',
							component: MySubscriptions,
							name: 'MySubscriptions'
						}
					]
				}
			]
		},
		{
			path: '/login',
			component: Login,
			name: 'Login',
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/maintenance',
			component: Maintenance,
			name: 'Maintenance'
			// meta: {
			// 	requiresAuth: false
			// }
		},
		{
			path: '/reset-password',
			component: Login,
			name: 'ResetPasswordEmailAsk',
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/subscribe',
			component: Subscribe,
			name: 'Subscribe',
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/anonymous',
			component: AnonymousLogin,
			name: 'AnonymousLogin',
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/anonymous-upgrade',
			component: AnonymousUpgrade,
			name: 'AnonymousUpgrade'
		},
		{
			path: '/subscribe-anonymous',
			component: AnonymousSubscribe,
			name: 'AnonymousSubscribe',
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/enterprise-subscribe',
			component: EnterpriseSubscribe,
			name: 'EnterpriseSubscribe',
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/reset-password/:token',
			component: ResetPassword,
			name: 'ResetPassword',
			meta: {
				requiresAuth: false
			}
		},
		{
			component: FromSign,
			path: '/from-sign/:status',
			name: 'FromSign'
		},
		{
			component: IndexLegal,
			path: '/legal',
			children: [
				{
					path: 'cgu',
					component: CGU,
					name: 'Cgu'
				},
				{
					path: 'cgv',
					component: CGV,
					name: 'Cgv'
				},
				{
					path: 'legals',
					component: Legals,
					name: 'Legals'
				},
				{
					path: 'confidentiality',
					component: Confidentiality,
					name: 'Confidentiality'
				}
			]
		},
		{
			path: '/demo',
			component: Demo,
			name: 'Demo'
		}
	]
})

myRouter.beforeEach((to, from, next) => {
	if (store.getters.isAuthenticated && store.getters.isTokenExpired) {
		store.commit('LOGOUT')
		next({ name: 'Login' })
	} else {
		if ((typeof to.meta.requiresAuth !== 'undefined' && to.meta.requiresAuth === false) && store.getters.isAuthenticated) {
			next({ name: 'Main' })
		} else if ((typeof to.meta.requiresAuth === 'undefined' || to.meta.requiresAuth === true) && !store.getters.isAuthenticated) {
			next({ name: 'Login' })
		} else {
			next()
		}
	}
})

export default myRouter



// WEBPACK FOOTER //
// ./src/router/index.js